import { render } from "./roles.vue?vue&type=template&id=10a556bf&scoped=true"
import script from "./roles.js?vue&type=script&lang=js"
export * from "./roles.js?vue&type=script&lang=js"

import "./roles.vue?vue&type=style&index=0&id=10a556bf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a556bf"]])

export default __exports__